//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		data(){
			return {
				imgSrc : 'https://api.abeiyun.com/www/yzm.php?yzm_type=num&rnd='+Math.random(),
				phone: '',
				email: '',
				imgNum:'',
				showPositionValue: false,
      			tiptxt:'',
      			tipType:'',
      			position: 'default',
      			getBox: '1',
      			titleTxt : '忘记密码',
      			showWay : false,
				txt: '请选择找回方式',
				show2: false,
			    menus2: {
			    	menu1: '通过手机找回',
			        menu2: '通过邮箱找回'
			    },
			    showP:'',
			    telNum: '',
			    emailNum : '',
			    showTel: '',
			    codeTarget: '',
			    codeNum:'',
			    password:'',
			    checkpassword:'',
          doStart:false,
          pcodebtn:false,
          ecodebtn:false,
          pcodetxt:'点击发送验证码',
          ecodetxt:'点击发送验证码',
          ptime:120,
          etime:120,
          passShow:false,
          passShow1:false
			}
		},
		mounted(){

		},
		methods:{
			getSrc(){
				this.imgSrc = 'https://api.abeiyun.com/www/yzm.php?yzm_type=num&rnd='+Math.random()
			},
			nextOne(){
				let data = 'cmd=get_mobile_email&phoneoremail='+this.phone+'&img_yzm='+this.imgNum;
				this.$http.post('https://api.abeiyun.com/www/reset_pwd.php',data).then(({data}) => {
					this.showPosition('middle')
					this.tiptxt = data.msg;
					if(data.response==200){
						this.tipType ='success';
						if(data.email){
							this.menus2={
                menu1: '通过手机找回',
								menu2: '通过邮箱找回'
							},
               this.telNum =data.phone;
						   this.emailNum = data.email
						}else {
              this.menus2={
                menu1: '通过手机找回',
              },
              this.telNum =data.phone;
              this.emailNum = data.email
            }
						setTimeout(() => {
							this.getBox = 2;
							this.titleTxt = '找回密码';
							this.showP = '8';
                        }, 1000);
					}else {
						this.tipType = 'warn';
						this.getSrc();
						this.imgNum = '';
					}

				})
			},
			showPosition (position) {
		      	this.position = position
		      	this.showPositionValue = true
		    },
		    click(key){
		    	if(key=='menu1'){
		    		this.showTel = '7';
		    		this.showP = '0';
		    		this.codeTarget = this.telNum

		    	}else if(key=="menu2"){
		    		this.showTel = '6';
		    		this.showP = '0';
		    		this.codeTarget = this.emailNum;
		    	}
				console.log(key)
			},
			sendCode(type){
			  if(type == 'phone'){
          this.pstart()
        }
        if(type == 'email'){
          this.estart()
        }
        this.doStart = true
				let data='cmd=send_yzm&phoneoremail='+this.codeTarget;
				this.$http.post('https://api.abeiyun.com/www/reset_pwd.php',data).then(({data})=>{
					this.showPosition('middle')
					this.tiptxt = data.msg;
					if(data.response==200){
						this.tipType = 'success'
					}else{
						this.tipType = 'warn'
					}
				})
			},
      pstart () {
        var _this = this
        if (this.ptime > 0) {
          this.pcodebtn = true
          this.ptime = this.ptime -1
          this.pcodetxt = this.ptime + "秒后重新发送"
          let timer = setTimeout(function () {
            _this.pstart()
          }, 1000);
        } else {
          this.pcodebtn = false
          this.pcodetxt = '再次发送验证码'
          this.ptime = 120;
        }
      },
      estart () {
        var _this = this
        if (this.etime > 0) {
          this.ecodebtn = true
          this.etime = this.etime -1
          this.ecodetxt = this.etime + "秒后重新发送"
          let timer = setTimeout(function () {
            _this.estart()
          }, 1000);
        } else {
          this.ecodebtn = false
          this.ecodetxt = '再次发送验证码'
          this.etime = 120;
        }
      },
		    checkCode(){
		    	let data='cmd=check_yzm&code='+this.codeNum
		    	this.$http.post('https://api.abeiyun.com/www/reset_pwd.php',data).then(({data})=>{
		    		console.log(data);
		    		this.showPosition('middle')
					this.tiptxt = data.msg;
					if(data.response==200){
						this.tipType = 'success',
						setTimeout(() => {
							this.getBox = 3;
							this.titleTxt = '重置密码';
                        }, 1200);
					}else{
						this.tipType = 'warn'
					}
		    	})
		   },
		   	setPsd(){
		   		let data = 'cmd=resetpwd&password='+this.password+'&checkpassword='+this.checkpassword;
		   		this.$http.post('https://api.abeiyun.com/www/reset_pwd.php',data).then(({data})=>{
					this.showPosition('middle')
					this.tiptxt = data.msg;
		   			if(data.response==200){
		   				this.tipType ='success';
		   				setTimeout(() => {
							this.$router.push('/login');
                        }, 1200);

		   			}else{
		   				this.tipType ='warn';
		   			}
		   		})
		   },
       changePassDisplay() {
         this.passShow = !this.passShow
       },
       changePassDisplay1() {
         this.passShow1 = !this.passShow1
       },
		}
	}



// WEBPACK FOOTER //
// ./src/components/user/forget.vue